import React from 'react';

import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import styles from './FormSuccessSubmit.module.scss';

type FormSuccessSubmitProps = {
  description: string;
};

const FormSuccessSubmit = ({ description }: FormSuccessSubmitProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles['form-success']} data-testid="form-success-submit">
      <Image
        className={styles['form-success__icon']}
        src="/icons/icon-consultation.svg"
        alt="call"
        width={90}
        height={90}
      />
      <h3 className={styles['form-success__title']}>{t('form-success-submit.title')}</h3>
      <p className={styles['form-success__description']}>{description}</p>
      <p className={styles['form-success__follow-title']}>{t('form-success-submit.social-links-title')}</p>
      <div className={styles['form-success__follow-links-list']}>
        <a href="https://www.facebook.com/visalexllc/" className={styles['form-success__follow-link']}>
          <Image src="/icons/icon-social-fb.svg" alt="facebook" width={20} height={20} />
          <span className="ml-1">{t('form-success-submit.follow')}</span>
        </a>
        <a href="https://www.instagram.com/visalex_llc/" className={styles['form-success__follow-link']}>
          <Image src="/icons/icon-social-ig.svg" alt="instagram" width={20} height={20} />
          <span className="ml-1">{t('form-success-submit.follow')}</span>
        </a>
        <a href="https://twitter.com/VisaLexLLC" className={styles['form-success__follow-link']}>
          <Image src="/icons/icon-social-tw.svg" alt="twitter" width={20} height={20} />
          <span className="ml-1">{t('form-success-submit.follow')}</span>
        </a>
      </div>
    </div>
  );
};

export default FormSuccessSubmit;
